<template>
  <recipe-label :value="time" icon="far fa-clock" v-if="time" />
</template>

<script>
import RecipeLabel from "./RecipeLabel";
export default {
  name: "RecipeLabelTime",
  components: { RecipeLabel },
  computed: {
    time() {
      if (this.cooking && this.prepare) {
        return this.cooking + " + " + this.prepare;
      } else if (this.prepare) {
        return this.prepare;
      } else if (this.cooking) {
        return this.cooking;
      } else {
        return null;
      }
    }
  },
  props: {
    cooking: {
      type: [Number, String],
      default: 0
    },
    prepare: {
      type: [Number, String],
      default: 0
    }
  }
};
</script>
